import { Component, Prop, Vue } from 'vue-property-decorator';
import VueQrcode from '@chenfengyuan/vue-qrcode';

@Component({
    components: {
        VueQrcode
    }
})
export default class QrCode extends Vue {
    @Prop()
    value: string;

    @Prop({ type: Object, default: () => ({ margin: 0, width: 140 }) })
    options: any;
}
